<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromSys" ref="fromSys" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.SYSNAME')">
                                    <td-input v-model="fromSys.sName"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click="btnAddSYS">{{ $t('common.ADD') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="false"
                :hasLoading="loading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                rowKey="sId"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-SysInfo
                v-if="dialogSysVisible"
                :isAddData="isAddData"
                :dialogSysVisible="dialogSysVisible"
                :editItem="editItem"
                :title="title"
                @sysDialogClose="sysDialogClose"
                @btnQuery="btnQuery"
            ></dialog-SysInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogSysInfo from './components/dialogSysInfo.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-SysInfo': dialogSysInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    beforeDestroy() {
        // resourceApi.destroy();
        // resourceApi = null;
        this.dialogRoleInfo = null;
        this.fromSys = null;
        this.editItem = null;
        this.dialogSysVisible = null;
        this.tableData = null;
        this.isAddData = null;
        this.pageSize = null;
        this.currentPage = null;
        this.total = null;
        this.loading = null;
        this.columns = null;
    },
    // 定义数据
    data() {
        return {
            permissionsAdd: ['sys:add'],
            permissionsEdit: ['sys:edit'],
            permissionsView: ['sys:view'],
            permissionsDel: ['sys:del'],
            fromSys: { sName: '', sIp: '' },
            editItem: '',
            dialogSysVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ]
            },
            columns: [
                {
                    prop: 'sName',
                    label: 'common.SYSNAME'
                },
                {
                    prop: 'sSysFlg',
                    label: 'common.SYSFLG'
                },
                {
                    prop: 'sUrl',
                    label: 'common.URL'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.sId, params.row.sSysFlg);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 查询按钮
        btnQuery() {
            this.currentPage = 1;
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            this.loading = true;
            var param = {
                name: this.fromSys.sName,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listSysInfo(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('sysManagement/listSysInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('sysManagement/listSysInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddSYS() {
            this.title = this.$t('common.ADD') + this.$t('common.SYSTEM'); // 标题
            this.isAddData = true;
            this.dialogSysVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT') + this.$t('common.SYSTEM');
            this.isAddData = false;
            this.dialogSysVisible = true;
        },
        // 删除接口
        delete(id, sysId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    var param = { id: id, sysId: sysId };
                    resourceApi.deleteSysInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.$log.error('sysManagement/deleteSysInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'));
                    this.$log.error('sysManagement/btnDelete---- Fail');
                });
        },
        // 关闭页面
        sysDialogClose() {
            this.dialogSysVisible = false;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    margin-left: 100px;
}
</style>
